import { ArrowUpDown, ArrowUp, ArrowDown } from "lucide-react";

interface CollectionJobsTableHeaderProps {
  sortColumn?: string;
  sortDirection?: "asc" | "desc";
  onSort: (column: string) => void;
}

export function CollectionJobsTableHeader({
  sortColumn,
  sortDirection,
  onSort,
}: CollectionJobsTableHeaderProps) {
  const getSortIcon = (column: string) => {
    if (sortColumn !== column) {
      return <ArrowUpDown className="h-4 w-4 ml-1.5 opacity-50 shrink-0" />;
    }
    return sortDirection === "desc" ? (
      <ArrowDown className="h-4 w-4 ml-1.5 shrink-0" />
    ) : (
      <ArrowUp className="h-4 w-4 ml-1.5 shrink-0" />
    );
  };

  return (
    <thead className="sticky top-0 z-10">
      <tr className="border-b border-grid-200 bg-grid-50">
        <th className="px-6 py-4 text-left text-xs font-semibold uppercase tracking-wider text-ink-600">
          <div
            className="flex items-center gap-1 cursor-pointer hover:opacity-80 select-none"
            onClick={() => onSort("status")}
          >
            Status
            {getSortIcon("status")}
          </div>
        </th>
        <th className="px-6 py-4 text-left text-xs font-semibold uppercase tracking-wider text-ink-600">
          Query
        </th>
        <th className="px-6 py-4 text-left text-xs font-semibold uppercase tracking-wider text-ink-600">
          <div
            className="flex items-center gap-1 cursor-pointer hover:opacity-80 select-none"
            onClick={() => onSort("created")}
          >
            Created
            {getSortIcon("created")}
          </div>
        </th>
        <th className="px-6 py-4 text-left text-xs font-semibold uppercase tracking-wider text-ink-600">
          <div
            className="flex items-center gap-1 cursor-pointer hover:opacity-80 select-none"
            onClick={() => onSort("triggeredBy")}
          >
            Triggered By
            {getSortIcon("triggeredBy")}
          </div>
        </th>
        <th className="px-6 py-4 text-left text-xs font-semibold uppercase tracking-wider text-ink-600">
          <div
            className="flex items-center gap-1 cursor-pointer hover:opacity-80 select-none"
            onClick={() => onSort("collected")}
          >
            Collected
            {getSortIcon("collected")}
          </div>
        </th>
        <th className="px-6 py-4 text-left text-xs font-semibold uppercase tracking-wider text-ink-600">
          <div
            className="flex items-center gap-1 cursor-pointer hover:opacity-80 select-none"
            onClick={() => onSort("classified")}
          >
            Classified
            {getSortIcon("classified")}
          </div>
        </th>
        <th className="px-6 py-4 text-left text-xs font-semibold uppercase tracking-wider text-ink-600">
          <div
            className="flex items-center gap-1 cursor-pointer hover:opacity-80 select-none"
            onClick={() => onSort("analyzed")}
          >
            Analyzed
            {getSortIcon("analyzed")}
          </div>
        </th>
        <th className="px-6 py-4 text-left text-xs font-semibold uppercase tracking-wider text-ink-600">
          <div
            className="flex items-center gap-1 cursor-pointer hover:opacity-80 select-none"
            onClick={() => onSort("started")}
          >
            Started
            {getSortIcon("started")}
          </div>
        </th>
        <th className="px-6 py-4 text-left text-xs font-semibold uppercase tracking-wider text-ink-600">
          <div
            className="flex items-center gap-1 cursor-pointer hover:opacity-80 select-none"
            onClick={() => onSort("completed")}
          >
            Completed
            {getSortIcon("completed")}
          </div>
        </th>
        <th className="px-6 py-4 text-left text-xs font-semibold uppercase tracking-wider text-ink-600">
          <div
            className="flex items-center gap-1 cursor-pointer hover:opacity-80 select-none"
            onClick={() => onSort("remainingSearchCredits")}
          >
            <span className="whitespace-nowrap">Remaining Search Credits</span>
            {getSortIcon("remainingSearchCredits")}
          </div>
        </th>
        <th className="px-6 py-4 text-left text-xs font-semibold uppercase tracking-wider text-ink-600">
          <div
            className="flex items-center gap-1 cursor-pointer hover:opacity-80 select-none"
            onClick={() => onSort("remainingCollectCredits")}
          >
            <span className="whitespace-nowrap">Remaining Collect Credits</span>
            {getSortIcon("remainingCollectCredits")}
          </div>
        </th>
        <th className="px-6 py-4 text-right text-xs font-semibold uppercase tracking-wider text-ink-600">
          Actions
        </th>
      </tr>
    </thead>
  );
}
